<div class="organization-companies-attached-card">
  <company-block-card [title]="'LABELS.IMPORTERS_OF_RECORD'" [isMarginBottom]="true">
    <ng-container *ngIf="isCompaniesExist && !(isTablet$ | async)" card-actions>
      <div class="header-container__actions" (click)="redirectToCreateCompany()">
        <img src="assets/icons/icon_add_gray.svg" />
        <span class="link">{{ "LABELS.IOR_ADD_ANOTHER_PROFILE" | translate }}</span>
      </div>
    </ng-container>

    <ng-container card-body>
      <div class="companies-container">
        <div *ngIf="!isCompaniesExist" class="companies-container__new-company" (click)="redirectToCreateCompany(true)">
          <img src="assets/icons/icon_add_gray.svg" />
          <span class="link">{{ "LABELS.IOR_CREATE_A_PROFILE" | translate }}</span>
        </div>
        <ng-container *ngIf="isCompaniesExist">
          <div class="companies-container__company-item" *ngFor="let company of companies" (click)="redirectToCompanyView(company.id)">
            <div class="companies-container__company-item-col">
              <div class="square" [ngStyle]="{ backgroundColor: !company.logoUri ? company.color : null }">
                <img src="{{ company.logoUri }}" />
              </div>
              <span class="name">{{ company?.businessName || "" | lengthLimit : 32 }}</span>
            </div>
            <div class="companies-container__company-item-col" *ngIf="!!this.organizationMembers && !(isTablet$ | async)">
              <app-gravatar
                *ngFor="let organizationMember of organizationCompanyMembers(company.id)"
                [acronymText]="organizationMember.user.firstName.charAt(0) + organizationMember.user.lastName.charAt(0)"
                [isNotificationOn]="organizationMember.role === enumOrganizationMemberRole.ADMIN"
              />
            </div>
          </div>
          <div class="companies-container__company-item-add" *ngIf="isTablet$ | async" (click)="redirectToCreateCompany()">
            <img src="assets/icons/icon_add_gray.svg" />
            <span class="link">{{ "LABELS.IOR_ADD_ANOTHER_PROFILE" | translate }}</span>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </company-block-card>
</div>
